import { useCallback, useMemo } from 'react';
import { BeaconEvent, sendEvent } from 'api/beacon';
import { usePageData } from 'state/pageData';
import { useSession } from 'state/session';
import { useWidget } from 'state/widget/context';
import { CommonEvent, PartialEvent, TrackEvent } from './types';

/**
 * Used within common contexts in the app to form the "base event" - common
 * properties which get sent to the API for any event.  The tracking function returned
 * allows the caller to dispatch events without having to worry about creating the
 * base event
 */
export default function useTrackEvent(): TrackEvent {
  const { url, widgetId } = usePageData();
  const { sessionId } = useSession();
  const {
    state: { domainId, prId, variantId },
  } = useWidget();

  const baseEvent: CommonEvent = useMemo(
    () => ({ domainId, prId, sessionId, url, widgetId, variantId }),
    [domainId, prId, sessionId, url, variantId, widgetId],
  );

  return useCallback(
    (event: PartialEvent<BeaconEvent>) => {
      sendEvent({ ...baseEvent, ...event });
    },
    [baseEvent],
  );
}
